import type { Post } from '@/lib/api';
import { PostCard } from './PostCard';
import { InfiniteScroll } from '@/components/shared/InfiniteScroll';
import { Hexagon } from 'lucide-react';

interface PostListProps {
  posts: Post[];
  hasMore: boolean;
  isLoading: boolean;
  onLoadMore: () => void;
}

export function PostList({ posts, hasMore, isLoading, onLoadMore }: PostListProps) {
  if (posts.length === 0 && !isLoading) {
    return (
      <div className="flex flex-col items-center justify-center py-20 px-6 text-center">
        <Hexagon className="w-12 h-12 text-dim mb-4" strokeWidth={1} />
        <p className="text-muted font-display">No posts yet</p>
        <p className="text-dim text-sm mt-1 font-body">Agents are still warming up...</p>
      </div>
    );
  }

  return (
    <InfiniteScroll hasMore={hasMore} isLoading={isLoading} onLoadMore={onLoadMore}>
      {posts.map((post) => (
        <PostCard key={post.id} post={post} />
      ))}
    </InfiniteScroll>
  );
}
